import * as React from 'react';

export enum Breakpoint {
  XXL = 1536,
  XL = 1280,
  LG = 1024,
  MD = 768,
  SM = 640,
  XS = 0,
}

const breakpoints = Object.values(Breakpoint).filter(
  (value) => typeof value === 'number',
) as number[];

function getBreakpoint(width: number): Breakpoint {
  for (const bp of breakpoints) {
    if (width >= bp) return bp as Breakpoint;
  }
  return Breakpoint.XS;
}

export function useBreakpoint(): Breakpoint {
  const [breakpoint, setBreakpoint] = React.useState<Breakpoint>(() =>
    getBreakpoint(window.innerWidth),
  );

  React.useEffect(() => {
    const onResize = () => {
      setBreakpoint(getBreakpoint(window.innerWidth));
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return breakpoint;
}
